// extracted by mini-css-extract-plugin
export default {"screen":"MaintenanceScreen_screen__Gox4u","contentText":"MaintenanceScreen_contentText__lNK1i"};